// extracted by mini-css-extract-plugin
module.exports = {"ReturnsHeader":"styles_ReturnsHeader__GI_7h","ReturnsHeader__itemsCount":"styles_ReturnsHeader__itemsCount__L8y1_"};